var header;
var windowWidth;
jQuery(document).ready(function(){
    header = jQuery('header');
    if(!header.length) return;
    let searchContainer = header.find('.search-action-container > div');
    header.find('.menu-toggler').click(function(){header.toggleClass('active');});
    header.find('.search-action-container > span').click(function(e){
        searchContainer.toggleClass('toggle');
        e.preventDefault();
        e.stopPropagation();
        jQuery(document.body).on('click', function(e) {
            if( !jQuery(e.target).is(searchContainer) && !jQuery.contains(searchContainer[0],e.target) ){
                jQuery(document.body).off('click');
                searchContainer.removeClass('toggle')
            }
        });
    });
    jQuery(window).resize(setWindowWidth);
    jQuery(window).scroll(checkHeaderTop);
    setWindowWidth();
    headerMenusToggle();
    checkHeaderTop();
});

function checkHeaderTop(){
    let scrollTop = jQuery(window).scrollTop();
    if(scrollTop>100) header.addClass('scroll');
    else header.removeClass('scroll');
}
function setWindowWidth(){
    windowWidth = jQuery(window).width();
    header.find('.main-menu-container nav > ul > li.menu-item-has-children.active').removeClass('active');

}
function headerMenusToggle(){
    let subMenu = header.find('.main-menu-container nav > ul > li.menu-item-has-children');
    subMenu.each(function(){
        let currentSubMenu = jQuery(this);
        currentSubMenu.hover(function(){
            if(windowWidth>1390){
                if(!header.find('.main-menu-container nav > ul > li.menu-item-has-children.active').length){
                    currentSubMenu.addClass('active');
                }else{
                    setTimeout(function(){
                        if(!header.find('.main-menu-container nav > ul > li.menu-item-has-children.active').length && currentSubMenu.is(':hover')) currentSubMenu.addClass('active');
                    },260)
                }
            }
        }, function(){
            if(windowWidth>1390) setTimeout(function(){
                if(!currentSubMenu.is(':hover')) currentSubMenu.removeClass('active');
            }, 250);
        }) 
        currentSubMenu.click(function(event){

            if (windowWidth <= 1390) {
                // Vérifiez si l'élément cliqué est l'exception
                if (currentSubMenu.find('> ul > li > ul.sub-menu > li.nav_solutions_we_love').length > 0 &&
                jQuery(event.target).closest('li').hasClass('nav_solutions_we_love')) {
                    // Empêcher le retrait de la classe active pour cette exception
                    return;
                }
                currentSubMenu.toggleClass('active');
            }
        })
    })
}